import request from '../../axios';

interface ILoanValidationResult {
  overall_score: number;
  loan_validation_letter: string;
}

export const getLoanValidationResult = async (loanGuid?: string) => {
  const {data}: {data: ILoanValidationResult} = await request.get(
    '/api/v2/payment/farm-validation/completed/loan-request/' + loanGuid,
  );

  return data;
};
